import React, { useEffect, useState } from "react";
import { PageTitle } from "../PageTitle";
import i18next from "i18next";
import { OpSenseToastContainer, toast } from "../Toast";
import { EventConfigurationsService, RolesService } from "../../services";

const triggerEventOptions = {
    'alert-acked': 'Alert Acknowledged'
};

const triggerActionOptions = {
    'SEND_TO_DIST_GROUP': 'Send To Distribution Group'
};

const distributionTypes = {
    'sms': 'SMS'
};

const EventWorkflowConfigurationView = ({ location, match }) => {
    const [workflowName, setWorkflowName] = useState(null);
    const [workflowTrigger, setWorkflowTrigger] = useState(null);
    const [workflowActionName, setWorkflowActionName] = useState(null);
    const [workflowActionType, setWorkflowActionType] = useState(null);
    const [workflowActionDetail, setWorkflowActionDetail] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);

        EventConfigurationsService.getWorkflow(match.params.eventConfigurationId).then((response) => {
            setWorkflowName(response.workflowConfiguration.name);
            const workflowConfiguration = JSON.parse(response.workflowConfiguration.configuration);

            const wft = workflowConfiguration.predicates.map((predicate) => {
                if (predicate.predicate.pathExpression) {
                    const triggerEventKey = Object.keys(triggerEventOptions).filter((key) => predicate.predicate.pathExpression.includes(key));
                    return triggerEventKey ? triggerEventOptions[triggerEventKey] : null;
                } else {
                    return null;
                }
            });
            setWorkflowTrigger(wft);

            workflowConfiguration.sinks.map((sink) => {
                setWorkflowActionName(triggerActionOptions[sink.type]);
                setWorkflowActionType(distributionTypes[sink.context.notificationType]);

                RolesService.get(sink.context.distributionGroupId).then(({role}) => {
                    setWorkflowActionDetail(role?.name);
                })
            });

            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.error(err);
            toast.error("Error loading workflow configuration.");
        })
    }, [match]);
    
    return loading ? (<div className="loader">Loading...</div>) : (
        <div>
            <OpSenseToastContainer />

            <div className="row">
                <PageTitle title={i18next.t("pages.event-workflow-configurations.view-header")} backLinkWithParams={{ link: { pathname: "/config/events", search: location?.state?.backLinkSearch } }} />
            </div>

            { workflowName && workflowTrigger && workflowActionName && workflowActionType && workflowActionDetail &&
                <div>
                    <div className="op-content-box">
                        <div className="row">
                            <div className="col-sm-6 col-md-4 form-group">
                                <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-name">
                                    <label>Name:</label> 
                                    <p>{workflowName}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="op-content-box">
                        <h4 className="remove-margin-bottom">Workflow Trigger</h4>
                        <div className="row">
                            <div className="col-sm-12 oc-mini-card oc-mini-card-gray">
                                <div className="inner">
                                    <div className="row">
                                        <div className="col-sm-6 col-md-4 col-lg-3">
                                            <label>Name:</label> 
                                            <p>{workflowTrigger}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="op-content-box">
                        <h4 className="remove-margin-bottom">Workflow Action</h4>
                        <div className="row">
                            <div className="col-sm-12 oc-mini-card oc-mini-card-gray">
                                <div className="inner">
                                    <div className="row">
                                        <div className="col-sm-6 col-md-4 col-lg-3">
                                            <label>Name</label>
                                            <p>{workflowActionName}</p>

                                            <label>Distribution Type</label>
                                            <p>{workflowActionType}</p>

                                            <label>Distribution Group</label> 
                                            <p>{workflowActionDetail}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            }
        </div>
    );
}

export default EventWorkflowConfigurationView;
